import React from "react";
import PropTypes from "prop-types";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Translate, getTranslation } from "orion-components/i18n";
import { formatAlertReference } from "./utils";

const AlertReference = ({ value, showLabel = true }) => {
	const displayValue = formatAlertReference(value);
	if (!displayValue) return null;

	const copyReference = event => {
		event.stopPropagation();
		navigator.clipboard?.writeText(displayValue);
	};

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				color: showLabel ? "#82878C" : "inherit",
				minHeight: showLabel ? "15px" : "inherit"
			}}
		>
			<Typography
				variant="inherit"
				sx={{
					fontSize: showLabel ? "11px" : "inherit",
					lineHeight: showLabel ? "13px" : "inherit",
					overflowWrap: "anywhere"
				}}
			>
				{showLabel && (
					<>
						<Translate value="global.sharedComponents.alertReference.label" />:{" "}
					</>
				)}
				{displayValue}
			</Typography>
			<Tooltip title={getTranslation("global.sharedComponents.alertReference.copy")} data-testid="orion-components-shared-components-alert-reference-alert-reference-tooltip">
				<IconButton
					size="small"
					onClick={copyReference}
					aria-label={getTranslation("global.sharedComponents.alertReference.copy")}
					sx={{
						color: "inherit",
						width: "15px",
						height: "15px",
						padding: "1px",
						marginLeft: "3px"
					}} data-testid="orion-components-shared-components-alert-reference-alert-reference-icon-button"
				>
					<ContentCopy sx={{ fontSize: "13px" }} />
				</IconButton>
			</Tooltip>
		</Box>
	);
};

AlertReference.propTypes = {
	value: PropTypes.string,
	showLabel: PropTypes.bool
};

export default AlertReference;
